import Vue from 'vue';
import App from './App.vue';
import './assets/js/ui_framework';
import http from './axios';
import './assets/css/reset.css';
import './assets/css/animate.min.css';


Vue.prototype.$http = http;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
